'use client'

import * as Sentry from '@sentry/nextjs'
import { useEffect } from 'react'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Capture error to Sentry
    Sentry.captureException(error)
  }, [error])

  return (
    <div className="flex min-h-[400px] flex-col items-center justify-center p-8">
      <div className="text-center">
        <h2 className="mb-4 text-2xl font-bold text-gray-900">
          Něco se pokazilo
        </h2>
        <p className="mb-6 text-gray-600">
          Omlouváme se, došlo k chybě. Zkuste to prosím znovu.
        </p>
        <button
          onClick={reset}
          className="rounded-lg bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 transition-colors"
        >
          Zkusit znovu
        </button>
      </div>
    </div>
  )
}
